import { useContext } from "react"
import AuthContext from "../context/AuthContext"

const CNT = () => useContext(AuthContext)

export default CNT;